// extracted by mini-css-extract-plugin
export default {"text":"TextWithLine_text__sKvAC","divider":"TextWithLine_divider__XZ62A"};